class BricksInPreSale {
    list;
    constructor(data) {
        this.list = data;
    }
}
export default BricksInPreSale;
